// TRANSLATION-SURFACE — shared Vietnamese copy for the booking-flow chrome.
export const SHARED_COPY = {
  back: 'Quay lại',
} as const;
